import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

export type ChartJsDoughnutDataType = {
    labels: string[];
    datasets: {
        label: string;
        data: number[];
        backgroundColor: string[];
        borderColor?: string[];
        borderWidth?: number;
    }[];
};

type ChartJsDoughnutProps = {
    data: ChartJsDoughnutDataType;
};
const ChartJsDoughnut: React.FunctionComponent<ChartJsDoughnutProps> = function ({ data }) {
    ChartJS.register(ArcElement, Tooltip, Legend);

    return <Doughnut data={data} />;
};

export default ChartJsDoughnut;
